import { defineStore } from 'pinia'
import _ from 'lodash'

export const useEventStore = defineStore('event', {
	state: () => {
		return {
			events: [],
		}
	},
	getters: {
		upcoming: (state) => {
			return state.events.filter((event) => event.start_at && event.completed == false)
		},
		featured: (state) => {
			return state.events.filter((event) => event.featured == true)
		},
	},
	actions: {
		setup() {
			this.getEvents()
		},
		getEvents() {
			return axios
				.get('/api/event')
				.then((events) => {
					this.events = events.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
